import { ApiEnum } from './api-enum'

export class ApiStatus {
  apiUrl: string;
  status: any;
  xoLibraries: any;
}